import React, { 
  useState,
  useEffect
} from "react";
import useStyles from "./stylesheet";
import { 
  FilterButtons,
  ProjectModal,
  Section,
} from "../../components";
import {
   collection,
   getDocs
} from "firebase/firestore";
import { 
  db
} from "../../../firebase";

const Works = () => {
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState("All");
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projectsRef = collection(db, "projects");
        const snapshot = await getDocs(projectsRef);
        
        const projectList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setProjects(projectList);
      } catch (err) {
        setError("Projeler yüklenemedi.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const filteredData = 
    activeTab === "All" ? projects : projects.filter((item) => item.type === activeTab.toLowerCase());

  return <div 
  className={classes.container}
  id="works"
  >
    <Section 
      title={"Portfolio"}
      background={true}
      border={true}
    >
      <FilterButtons onTabChange={setActiveTab} />
    </Section>
    <div className={classes.tabs}>
      {
        loading ?
        <div
          className={classes.dangerText}
        >
          Yükleniyor...
        </div>
        :
        error ?
        <div
          className={classes.dangerText}
        >
          Projeler yüklenemedi sayfayı yenilemeyi deneyin...
        </div>
        :
        filteredData.map((item) => (
          <div
            className={classes.imgContainer}
            key={item.id}
            onClick={() => {
              setModalVisible(true);
              setModalData(item);
            }}
          >
            <img 
              className={classes.img}
              src={item.imageURL}
              alt=""
            />
            <div 
              className={classes.overlay}
            >
              <span 
                className={classes.text}
              >
                {item.title}
              </span>
            </div>
          </div>
        ))
      }
    </div>
    <ProjectModal
    onClose={() => setModalVisible(false)}
    visible={modalVisible}
    data={modalData}
  />
  </div>
};

export default Works;
